// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1RvEU","title":"AfterFrontImage_title__2gSJs"};